import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './clients.css';

// Routes
import Application from './components/application';
import Landing from './components/landing';

ReactDOM.render(<BrowserRouter basename={'/funeral'}>
  <div>

    <nav>
      <div className='container'>
        <a href='/'><img src='/funeral/logo.png' height='30px' /></a>
      </div>
    </nav>
    <div className='header' id='funeralHeader'>
      <h1 id='hname'>Funeral cover</h1>
    </div>
    <Route exact path='/' component={Landing} />
    <Route exact path='/apply' component={Application} />
  </div>
</BrowserRouter>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js